import PropTypes from 'prop-types';
import React from 'react';
import { getOrgTermsContent } from '../../content/utils.js';
import {
  ChangeImpactsLink,
  ChangeStrategiesLink,
  InitiativesLink,
  ProjectFilesLink,
  ProjectLink,
  ProjectStakeholdersLink,
} from '../links/index.jsx';
import Tabs from '../Tabs.jsx';

const ProjectTabs = ({ project }) => (
  <Tabs>
    {project.dashboardPage !== false && (
      <Tabs.Tab label="Dashboard">
        <ProjectLink projectId={project.id} />
      </Tabs.Tab>
    )}
    <Tabs.Tab label={getOrgTermsContent('initiatives')}>
      <InitiativesLink projectId={project.id} />
    </Tabs.Tab>
    <Tabs.Tab label="Change Impacts">
      <ChangeImpactsLink projectId={project.id} />
    </Tabs.Tab>
    <Tabs.Tab label="Linked Files">
      <ProjectFilesLink projectId={project.id} />
    </Tabs.Tab>
    {project?.manageProject && (
      <Tabs.Tab label="Stakeholder Analysis">
        <ProjectStakeholdersLink projectId={project.id} />
      </Tabs.Tab>
    )}
    {project?.manageProject ? (
      <Tabs.Tab label="Change Strategy">
        <ChangeStrategiesLink projectId={project.id} />
      </Tabs.Tab>
    ) : null}
  </Tabs>
);

ProjectTabs.propsTypes = {
  project: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default ProjectTabs;
